<div data-test-id="medio-redirect-loading-wrapper"  class="loading">
  <div data-test-id="medio-redirect-loading"  class="wrapper">
    <app-spinner data-test-id="medio-redirect-loading-spinner"></app-spinner>
  </div>
</div>
